import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAnalyticsResource } from './analytics.types';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsResource implements IAnalyticsResource {
  private analyticsId: string | null = null;

  constructor(private http: HttpClient) {}

  setId(id: string) {
    this.analyticsId = id;
  }

  getId() {
    if (!this.analyticsId) {
      this.generateAnalyticsId();
    }

    return this.analyticsId!;
  }

  private generateAnalyticsId() {
    this.analyticsId = uuidv4();
  }
}
